/* AERON Sportswear — Global JS */
(function(){
'use strict';

/* ── CURSOR ─────────────────────────────────────────────── */
var cur = document.getElementById('a-cur');
var ring = document.getElementById('a-ring');
if (cur && ring && window.matchMedia('(hover:hover)').matches) {
  var mx=0, my=0, rx=0, ry=0;
  document.addEventListener('mousemove', function(e) {
    mx = e.clientX; my = e.clientY;
    cur.style.left = mx + 'px';
    cur.style.top  = my + 'px';
  });
  (function loop() {
    rx += (mx - rx) * 0.1;
    ry += (my - ry) * 0.1;
    ring.style.left = rx + 'px';
    ring.style.top  = ry + 'px';
    requestAnimationFrame(loop);
  })();
  document.querySelectorAll('a,button,.oc,.prod-card,.gal-cell,.strip-item').forEach(function(el) {
    el.addEventListener('mouseenter', function() {
      cur.style.width  = '16px'; cur.style.height = '16px';
      ring.style.width = '50px'; ring.style.height= '50px';
    });
    el.addEventListener('mouseleave', function() {
      cur.style.width  = '10px'; cur.style.height = '10px';
      ring.style.width = '34px'; ring.style.height= '34px';
    });
  });
}

/* ── NAV SCROLL ─────────────────────────────────────────── */
var nav = document.getElementById('nav');
if (nav) {
  function checkScroll() { nav.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();
}

/* ── MOBILE MENU ─────────────────────────────────────────── */
window.openMenu = function() {
  var m = document.getElementById('mmenu');
  var b = document.getElementById('burger');
  if (!m || !b) return;
  m.classList.toggle('open');
  b.classList.toggle('open');
  document.body.style.overflow = m.classList.contains('open') ? 'hidden' : '';
};

/* ── SCROLL REVEAL ───────────────────────────────────────── */
var ro = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('on'); });
}, { threshold: 0.08 });
document.querySelectorAll('.rv').forEach(function(el) { ro.observe(el); });

/* ── STAT COUNTERS ───────────────────────────────────────── */
var so = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (!e.isIntersecting) return;
    var el = e.target;
    var target = parseInt(el.dataset.n, 10);
    var suffix = el.dataset.s || '';
    var dur = 1200, start = null;
    function run(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var v = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(v * target) + suffix;
      if (p < 1) requestAnimationFrame(run);
    }
    requestAnimationFrame(run);
    so.unobserve(el);
  });
}, { threshold: 0.5 });
document.querySelectorAll('[data-n]').forEach(function(el) { so.observe(el); });

/* ── POPUP ───────────────────────────────────────────────── */
window.closePop = function() {
  var o = document.getElementById('pop');
  if (o) { o.classList.remove('on'); document.body.style.overflow = ''; }
  try { sessionStorage.setItem('aeronPop', '1'); } catch(x) {}
};
var pop = document.getElementById('pop');
if (pop) {
  pop.addEventListener('click', function(e) { if (e.target === pop) closePop(); });
  if (!sessionStorage.getItem('aeronPop')) setTimeout(function() {
    pop.classList.add('on');
    document.body.style.overflow = 'hidden';
  }, 2400);
}

/* ── FILE UPLOAD LABEL ───────────────────────────────────── */
window.showFiles = function(input) {
  var el = document.getElementById('fnames');
  if (el) el.textContent = Array.from(input.files).map(function(f) { return f.name; }).join(', ');
};

/* ── HERO PARTICLE CANVAS ────────────────────────────────── */
var canvas = document.getElementById('hero-canvas');
if (canvas) {
  var ctx = canvas.getContext('2d');
  var W, H, pts = [];
  function resize() {
    W = canvas.width = innerWidth;
    H = canvas.height = innerHeight;
    pts = [];
    for (var i = 0; i < 48; i++) {
      pts.push({ x: Math.random()*W, y: Math.random()*H,
        vx: (Math.random()-.5)*.26, vy: (Math.random()-.5)*.26,
        r: Math.random()*1.2+.4, a: Math.random() });
    }
  }
  function draw() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < pts.length; i++) {
      var p = pts[i];
      p.x += p.vx; p.y += p.vy;
      if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
      if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(198,169,98,' + (p.a * 0.14) + ')';
      ctx.fill();
      for (var j = i+1; j < pts.length; j++) {
        var q = pts[j];
        var dx = p.x-q.x, dy = p.y-q.y, d = Math.sqrt(dx*dx+dy*dy);
        if (d < 120) {
          ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(q.x,q.y);
          ctx.strokeStyle = 'rgba(198,169,98,' + (0.045*(1-d/120)) + ')';
          ctx.lineWidth = 0.5; ctx.stroke();
        }
      }
    }
    requestAnimationFrame(draw);
  }
  window.addEventListener('resize', resize);
  resize(); draw();
}

/* ════════════════════════════════════════════════════════════
   KIT CONFIGURATOR — only runs on the kits page
   ════════════════════════════════════════════════════════════ */
if (!document.getElementById('cfg-build')) return;

var jP = { 10:45, 50:40, 100:37, 200:34, 500:31 };
var sP = { 10:55, 50:50, 100:46, 200:42, 500:38 };

function base(q, kit) {
  var t = kit === 'shorts' ? sP : jP;
  if (q >= 500) return t[500]; if (q >= 200) return t[200];
  if (q >= 100) return t[100]; if (q >= 50)  return t[50];
  return t[10];
}
function fmt(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
function ship(q) { return q >= 100 ? 0 : q >= 50 ? 150 : q >= 30 ? 100 : 75; }

var kit = 'jersey';
var ad  = { names:false, spon:false, emb:false, socks:false };
var sponN = 1, colUp = 0, colName = 'Round', qty = 20;

window.setKit = function(el, type) {
  kit = type;
  document.querySelectorAll('[data-kit]').forEach(function(c) { c.classList.remove('on'); });
  el.classList.add('on'); calc();
};
window.togAd = function(el, key) {
  ad[key] = !ad[key]; el.classList.toggle('on', ad[key]);
  var w = document.getElementById('spon-wrap');
  if (key === 'spon' && w) w.style.display = ad[key] ? 'flex' : 'none';
  calc();
};
window.adjSpon = function(d) {
  sponN = Math.max(1, Math.min(3, sponN+d));
  var el = document.getElementById('spon-n'); if (el) el.textContent = sponN; calc();
};
window.setCollar = function(el, name, up) {
  colUp = up; colName = name;
  document.querySelectorAll('[data-col]').forEach(function(c) { c.classList.remove('on'); });
  el.classList.add('on'); calc();
};
window.setQty = function(v) {
  qty = parseInt(v, 10);
  var el = document.getElementById('qty-disp');
  if (el) el.textContent = qty >= 500 ? '500+' : v; calc();
};

function line(id, pid, show, amt) {
  var l = document.getElementById(id), p = document.getElementById(pid);
  if (show) { if (l) l.style.display='flex'; if (p) p.textContent=fmt(amt); return amt; }
  if (l) l.style.display = 'none'; return 0;
}

function calc() {
  var b = base(qty, kit), tot = b * qty;
  var jc = document.getElementById('pJerseyCard'), sc = document.getElementById('pShortsCard');
  if (jc) jc.textContent = '$' + base(qty,'jersey') + ' / jersey';
  if (sc) sc.textContent = '$' + base(qty,'shorts') + ' / set';
  var lb = document.getElementById('lBase'), pb = document.getElementById('pBase');
  if (lb) lb.textContent = (kit==='shorts' ? 'APEX + Shorts' : 'APEX Jersey') + ' ×' + qty;
  if (pb) pb.textContent = fmt(b * qty);
  tot += line('lCol',   'pCol',   colUp>0,        colUp*qty);
  tot += line('lNames', 'pNames', ad.names,        5*qty);
  tot += line('lSpon',  'pSpon',  ad.spon,         3*sponN*qty);
  tot += line('lEmb',   'pEmb',   ad.emb,          4*qty);
  tot += line('lSocks', 'pSocks', ad.socks,        18*qty);
  var sh = ship(qty), ps = document.getElementById('pShip');
  if (ps) { if (!sh) { ps.textContent='Free'; ps.style.color='#28C76F'; }
            else     { ps.textContent=fmt(sh); ps.style.color=''; } }
  tot += sh;
  var pt = document.getElementById('pTot'), pu = document.getElementById('pUnit');
  if (pt) pt.textContent = fmt(tot);
  if (pu) pu.textContent = 'approx. ' + fmt(tot/qty) + ' per jersey';
  var sf=document.getElementById('sFreeMsg'), sp=document.getElementById('sPaidMsg'), sm=document.getElementById('sShipTxt');
  if (sf) sf.classList.toggle('on', !sh);
  if (sp) sp.classList.toggle('on', !!sh);
  if (sm && sh) sm.textContent = fmt(sh) + ' shipping — free on 100+';
}
calc();

/* FORM SUBMIT */
window.submitKit = function(e) {
  e.preventDefault();
  var btn = document.getElementById('submitBtn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  var parts = [
    '=== AERON ORDER SUMMARY ===',
    'Kit: ' + (kit==='shorts' ? 'APEX Jersey + Shorts' : 'APEX Jersey Only'),
    'Quantity: ' + qty,
    'Collar: ' + colName + (colUp > 0 ? ' (+$' + colUp + '/jersey)' : ''),
    'Add-Ons:'
  ];
  if (ad.names) parts.push('  - Player Names & Numbers (+$5/jersey)');
  if (ad.spon)  parts.push('  - Sponsor Logo Premium Print: ' + sponN + ' logo(s) (+$' + (3*sponN) + '/jersey)');
  if (ad.emb)   parts.push('  - Embroidered Club Crest (+$4/jersey)');
  if (ad.socks) parts.push('  - Launch Pads Grip Socks (+$18/pair)');
  if (!ad.names && !ad.spon && !ad.emb && !ad.socks) parts.push('  - None selected');
  var pt = document.getElementById('pTot');
  parts.push('Estimated Total: ' + (pt ? pt.textContent : 'N/A'));
  var sf = document.getElementById('supplierField');
  if (sf) sf.value = parts.join('\n');
  var form = document.getElementById('kitForm');
  if (!form) return;
  try { sessionStorage.setItem('aeronBrief', parts.join('\n')); } catch(x) {}
  fetch('/', { method:'POST', body: new FormData(form) }).catch(function(){}).finally(function() {
    form.style.display = 'none';
    var ok = document.getElementById('kitOk');
    if (ok) { ok.style.display = 'block'; ok.scrollIntoView({ behavior:'smooth' }); }
    var dep = form.dataset.deposit;
    if (dep && dep.length > 4) setTimeout(function() { window.location.href = dep; }, 2600);
  });
};

})();
